import { useState } from 'react';

import { calculateEndDate, generatedId } from '../../utils/helper';

const SprintCreationForm = ({ setShowForm, setallData }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: 'sprint',
    duration: '1 week',
    noOfissues: 0,
    startDate: '',
    endDate: '',
    objective: '',
    issues: [],
  });

  const handleChange = (e) => {
    const { value, id } = e.target;
    setFormData((prev) => {
      const updatedData = { ...prev, [id]: value };

      if (id === 'startDate' || id === 'duration') {
        updatedData.endDate = calculateEndDate(
          updatedData.startDate,
          updatedData.duration,
        );
      }

      return updatedData;
    });
  };

  const handleSprintCreation = (e) => {
    e.preventDefault();
    const newSprint = { id: generatedId(), ...formData };
    setallData((prev) => {
      const updatedData = [...prev];
      const backlogIndex = updatedData.findIndex(
        (item) => item.type === 'backlog',
      );

      if (backlogIndex === -1) {
        return [...updatedData, newSprint];
      }

      updatedData.splice(backlogIndex, 0, newSprint);
      return updatedData;
    });
    setShowForm(false);
  };

  return (
    // eslint-disable-next-line
    <div
      className="w-1/3 rounded-xl border bg-[#1d1d1f] p-6"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-lg font-bold text-gray-400">Create New Sprint</h3>
      <form
        action=""
        className="w-full"
        onSubmit={(e) => handleSprintCreation(e)}
      >
        <div className="my-4 flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <label
              htmlFor="name"
              className="text-sm font-semibold text-gray-600"
            >
              Sprint Name
            </label>
            <input
              type="text"
              id="name"
              className="rounded-md border bg-[#28282a] p-1 text-sm text-gray-100 focus:outline-none"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="duration"
              className="text-sm font-semibold text-gray-600"
            >
              Duration
            </label>
            <select
              id="duration"
              className="rounded-md border bg-[#28282a] p-1 text-sm text-gray-100 focus:outline-none"
              value={formData.duration}
              onChange={handleChange}
            >
              <option value="1 week">1 Week</option>
              <option value="2 weeks">2 Weeks</option>
              <option value="3 weeks">3 Weeks</option>
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="startDate"
              className="text-sm font-semibold text-gray-600"
            >
              Start date
            </label>
            <input
              type="date"
              id="startDate"
              className="rounded-md border bg-[#28282a] p-1 text-sm text-gray-100 focus:outline-none"
              value={formData.startDate}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="endDate"
              className="text-sm font-semibold text-gray-600"
            >
              End date
            </label>
            <input
              type="date"
              id="endDate"
              className="rounded-md border bg-[#28282a] p-1 text-sm text-gray-100 focus:outline-none"
              value={formData.endDate}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label
              htmlFor="objective"
              className="text-sm font-semibold text-gray-600"
            >
              Sprint goal
            </label>
            <textarea
              id="objective"
              rows={3}
              className="rounded-md border bg-[#28282a] p-1 text-sm text-gray-100 focus:outline-none"
              value={formData.objective}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex w-full items-center justify-end gap-6">
          <button
            className="rounded-xl bg-gradient-to-b from-[#5566FF] to-[#333D99] px-3 py-1 font-semibold text-gray-300"
            type="button"
            onClick={() => setShowForm(false)}
          >
            Cancel
          </button>
          <button
            className="rounded-xl bg-gradient-to-b from-[#5566FF] to-[#333D99] px-3 py-1 font-semibold text-gray-300"
            type="submit"
          >
            Create
          </button>
        </div>
      </form>
    </div>
  );
};

export default SprintCreationForm;
